<template>
  <div class="container-modal-upsell">
    <div class="wrapper-plans">
      <p>{{ t('question_restart_plan', { plan }) }}</p>
      <p v-if="plan === 'Pro'">{{ t('ss_resume_subscription_body') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    plan: string;
  }>(),
  {}
);

const { t } = useI18n();
</script>

<style scoped lang="scss">
.container-modal-upsell {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.wrapper-plans {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  p {
    text-align: center;
    margin-bottom: 1rem;
  }
}
</style>
